import * as React from 'react';
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";

import * as styles from './style.css';
import Icon from "../../../icons/Icon";
import UQButton from "../button";

class ConfirmModal extends React.PureComponent {

  static defaultProps = {
    show: false,
    timeout: 400,
    title: '',
    showConfirmBtn: true,
    showCancelBtn: false,
    confirmLabel: 'Ok',
    cancelLabel: 'Cancel',
    onConfirm: () => {},
    onClose: () => {}
  };

  static propTypes = {
    show: PropTypes.bool,
    timeout: PropTypes.number,
    title: PropTypes.string,
    showConfirmBtn: PropTypes.bool,
    showCancelBtn: PropTypes.bool,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    confirmBtnStyles: PropTypes.any,
    cancelBtnStyles: PropTypes.any,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    onClose: PropTypes.func,
    isMemorialTheme: PropTypes.bool
  };
  
  render() {
    return (
      <CSSTransition
        in={this.props.show}
        timeout={400}
        classNames="fade"
        unmountOnExit
        mountOnEnter>
        <div className={styles.modalContainer} style={this.props.styles}>
          <div className={styles.modal}>
            <div onClick={this.props.onClose}
                 className={ this.props.isMemorialTheme ? styles.modalClose_memorial : styles.modalClose }>
              <Icon name={ this.props.isMemorialTheme ? 'ModalCloseSmallDark' : 'ModalCloseSmall' } width="12px" height="12px"/>
            </div>
            <div className={`${styles.modalTitle} font-title`}>{this.props.title}</div>
            <div className={styles.modalText}>
              {this.props.children}
            </div>
            { this.props.showConfirmBtn && (
              <UQButton innerClass={styles.confirmButtonInner}
                        theme={ this.props.isMemorialTheme ? 'memorial' : 'brand' }
                        label={this.props.confirmLabel}
                        containerStyle={{ marginTop: '28px', ...this.props.confirmBtnStyles }}
                        onPress={this.props.onConfirm}/>
            ) }
            { this.props.showCancelBtn && (
              <UQButton innerClass={styles.confirmButtonInner}
                        theme={ this.props.isMemorialTheme ? 'whiteDarkText' : 'white' }
                        label={this.props.cancelLabel}
                        containerStyle={{ marginTop: '28px', ...this.props.cancelBtnStyles }}
                        onPress={this.props.onCancel}/>
            ) }
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/app/modules/uq-ui/components/confirm-modal/index.jsx